/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () =>
  chance.pickset(
    [
      {
        countryCode: 'AU',
        description: 'All Melbourne VIC',
        id: 1002,
        shortDescription: 'Melbourne, Victoria',
      },
      {
        id: 5071,
        description: 'Eastern Suburbs Melbourne VIC',
        shortDescription: 'Eastern Suburbs, Victoria',
        countryCode: 'AU',
      },
      {
        countryCode: 'HK',
        description: 'Kwun Tong Kwun Tong District HK',
        id: 1000132,
        shortDescription: 'Kwun Tong Kwun Tong District HK',
      },
      {
        countryCode: 'ID',
        description: 'Klaten Central Java ID',
        id: 2030806,
        shortDescription: 'Klaten Central Java ID',
      },
      {
        countryCode: 'MY',
        description: 'Johor MY',
        id: 1000178,
        shortDescription: 'Johor MY',
      },
      {
        id: 5118,
        description: 'Auckland Central Auckland NZ',
        shortDescription: 'Auckland Central, Auckland',
        countryCode: 'NZ',
      },
      {
        countryCode: 'PH',
        description: 'Cagayan Valley PH',
        id: 2060400,
        shortDescription: 'Cagayan Valley PH',
      },
      {
        countryCode: 'SG',
        description: 'Ang Mo Kio North-East Region SG',
        id: 2701201,
        shortDescription: 'Ang Mo Kio North-East Region SG',
      },
      {
        countryCode: 'TH',
        description: 'Amnat Charoen TH',
        id: 2080600,
        shortDescription: 'Amnat Charoen TH',
      },
    ],
    chance.integer({ min: 0, max: 5 }),
  );
